import React,{useEffect, useState} from "react";
import { DATE_FORMAT4 } from "../../../constants/stringConstants";
import { useAddEducationMutation, useEditEducationMutation } from "../../../store/profileSlice";
import { useAppSelector } from "../../../store/store";
import DropdownComponent from "../../DropdownComponent";
import ModalContainer from "../../ModalContainer";
import ModalDatePicker from "../../ModalDatePicker"; 
import ModalInputField from "../../ModalInputField";  
import moment from "moment"; 
import { cloneDeep, isEmpty } from "lodash";
import HeaderModalText from "../../HeaderModalText";
import ImageUploader from "../../ImageUploader";
import PdfUploadingComponent from "../../PdfUploadingComponent";
 
function ProfileCompletionEducationModal({editData,isVisible,onClose})  { 
console.log({editData})
    const [input, setInput] = useState({
        degree:editData?.nameOfDegree??"",
        degreeId:editData?.degreeId??"",
        uni:editData?.institute?? "",  
        startDate:editData?.from?? "",  
        endDate:editData?.to??"",
      });

      const [error, setError] = useState({
        degree:'',
        uni:'', 
        startDate:'',
        endDate:'',
      });

      const[loading,setLoading]=useState(false)
      const { user,allEducations } = useAppSelector((state) => state["user"]);
      const [addEducation] =
      useAddEducationMutation();
      const [editEducation] =
      useEditEducationMutation();
      const [imageFile, setImageFile] = useState(editData?.degreeImage??'');
      const[listingEducations,setListingEducations]=useState([])
      




  useEffect(()=>{
    let educations=allEducations.map((item)=>{
      let data={
        label:item.title,
        value:item.id
      }
      return data
    })
    
    setListingEducations(educations)
    
    },[]) 



const onChangeText = (event) => {
    setInput({
      ...input,
      [event.target.name]: event.target.value,
    });
  };
 
 
  const onChangeStartDate=(date)=>{
    setInput({ ...input, startDate: `${date}` });
  }

  const onChangeEndDate=(date)=>{
    setInput({ ...input, endDate: `${date}` });
  }
 

const getDropDownValue=(val)=>{
console.log({educations:val})
setInput({ ...input, degreeId: `${val}` });

}

const errorSec = (err) => (
  <div style={{ marginBottom: "20px" }}>
    <text style={{ color: "red" }}>{err}</text>
  </div>
);

const validation=()=>{

  const{ 
    degreeId,
  uni, 
  startDate, 
  endDate}=input
   
  let valid = true;
  let degreeError = "";
  let uniError = "";
  let startDateError = "";
  let endDateError = "";
  
  
  if (isEmpty(degreeId)) {
    valid = false;
    degreeError = "You need to select a degree";
  }
  
  if (isEmpty(uni)) {
    valid = false;
    uniError = "University name cannot be empty";
  } 
  
  if (isEmpty(startDate)) {
    valid = false;
    startDateError = "You need to select a start date";
  }
  
  
  if(isEmpty(endDate) ){
    valid = false;
    endDateError = "You need to select an end date";
  }
  
  
  setError({
    ...error,
    degree:degreeError,
    uni:uniError,
    startDate:startDateError,
    endDate:endDateError,
  });
  
  return valid; 
  };


  const asterikSign = () => (
    <h2
      style={{
        color: "red",
        fontSize: "20px",
        marginLeft: "5px",
        height:10,
        marginTop:-4
      }}
    >
      {" "}
      *
    </h2>
  );
  

  const addEditEducation=()=>{

    if(validation()){
      setLoading(true)

  const selectedEdu = listingEducations.find(function (element) {
    console.log({element})
    return element.value === input.degreeId ;
  });
  console.log({selectedEdu})
  
     
    let educationData={
      nameOfDegree:selectedEdu.label,
      degreeId:selectedEdu.value,
      institute:input.uni,
      from:moment(input.startDate).format(DATE_FORMAT4),
      to:moment(input.endDate).format(DATE_FORMAT4),
      degreeImage:imageFile
     }
    
     console.log({educationData})
    let payload={}
    
    //add course
    if(isEmpty(editData)){
     payload={
    param:user?.id??'',
    data:[educationData]
    }
    
    
        addEducation(payload)
          .unwrap()
          .then((incomingData) => {
            setLoading(false)

            console.log({ incomingData });
            onClose()
          })
          .catch((err) => {
            setLoading(false)

            console.log(err);
          });
    
        }
    
        //edit course
    
        else{
          payload={
            param:editData?.id??'',
            data:educationData
            }
          editEducation(payload)
          .unwrap()
          .then((incomingData) => {
            setLoading(false)

            console.log({ incomingData });
            onClose()
          })
          .catch((err) => {
            setLoading(false)

            console.log(err);
          });
    
        }
      }
      }
   
 
  return (
<ModalContainer onClose={onClose} onBtnClick={addEditEducation} isVisible={isVisible}
modalHeaderText={""}
modalSubHeaderText={isEmpty(editData)?"Add Education":"Edit Education"}
isLoading={loading}
>
    
     <div style={{marginBottom:'2rem'}}>  
     <div style={{display:"flex",flexDirection:'row'}}>
<HeaderModalText text={"Degree"}/>
{asterikSign()} 
</div> 
    <DropdownComponent getValue={getDropDownValue} dataList={listingEducations} value={input?.degreeId} hasError={!isEmpty(error.degree)}/>
    {!isEmpty(error.degree) && errorSec(error.degree)}

    </div>
 
    <div style={{marginBottom:'2rem'}}>   
<ModalInputField isRequired={true} name={'uni'} headerText={'University'} onChangeText={onChangeText} inputFieldValue={input.uni} hasError={!isEmpty(error.uni)}/>
{!isEmpty(error.uni) && errorSec(error.uni)}

</div>

<div style={{marginBottom:'2rem'}}>   
<ModalDatePicker isRequired={true} headerText={"Start Date"} handleChangeDate={onChangeStartDate} dateValue={input.startDate}  hasError={!isEmpty(error.startDate)}/>
{!isEmpty(error.startDate) && errorSec(error.startDate)}

</div>   

<div style={{marginBottom:'2rem'}}>   
<ModalDatePicker isRequired={true} headerText={"End Date"} handleChangeDate={onChangeEndDate} dateValue={input.endDate}  hasError={!isEmpty(error.endDate)}/>
{!isEmpty(error.endDate) && errorSec(error.endDate)}

</div>   

<div style={{flexDirection:'column',flex:1,display:'flex'}} >
  <HeaderModalText text={"Degree Document"}/>
  <PdfUploadingComponent setFile={setImageFile} imageFile={imageFile}/>

</div> 



</ModalContainer>
  );
}

export default ProfileCompletionEducationModal;
